import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'luci-button',
  templateUrl: './luci-button.component.html',
  styleUrls: ['./luci-button.component.scss']
})
export class LuciButtonComponent implements OnInit {

  @Input() isButtonText = '';
  @Input() isButtonSize = '';
  @Input() isPrimary = false;
  @Input() isIcon = false;
  @Input() isIconOnly = false;
  @Input() isDisabled = false;
  @Input() isIconText = '';
  @Input() isIconColor = '';
  @Input() isToggle = false;
  @Input() isImg = false;
  @Output() clickCallBack = new EventEmitter();
  @Input() classList = '';

  constructor() { }

  ngOnInit(): void {

  }


  getButtonStyle(val, type, iconOnly) {
    if (val === 'small' && type && !iconOnly) {
      return 'luci-button--primary luci-button--small';
    } else if (val === 'small' && !type && !iconOnly) {
      return 'luci-button--small';
    } else if (type && !iconOnly) {
      return 'luci-button--primary';
    } else if (val !== 'small' && iconOnly && !type) {
      return 'luci-button--icon-only';
    } else if (val !== 'small' && type && iconOnly) {
      return 'luci-button--primary luci-button--icon-only';
    } else if (val === 'small' && type && iconOnly) {
      return 'luci-button--primary luci-button--small luci-button--icon-only';
    } else if (val === 'small' && !type && iconOnly) {
      return 'luci-button--small luci-button--icon-only';
    }
  }

  clickFn() {
    console.log('clicked');
    this.clickCallBack.emit();
  }

  getIcon() {
    return `assets/icons/luci.svg#${this.isIconText}`;
  }

  getImage() {
    return `assets/icons/${this.isIconText}.svg`;
  }

}
